import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import BillAutomationPage from 'portal/src/pages/billAutomation/BillAutomationPage';

import { billAutomationRouteDefinitions } from './BillAutomationRouteDefinitions';
import { generatePageWithTabsRoute } from './routeGenerator';

const BillAutomationRoutes: RouteObject = generatePageWithTabsRoute(
  'Automated bill data entry and QA',
  BASE.BILL_AUTOMATION,
  NESTED_ROUTES.BILL_AUTOMATION.SUMMARY,
  billAutomationRouteDefinitions,
  BillAutomationPage,
);

export default BillAutomationRoutes;
